import store from  '../store'
import * as types from '../store/types'
import axios from 'axios'
import qs from 'qs'
import router from '../router'
import tips from "../estoast";

import {$encruptionData} from './jssHttp'





let instance = axios.create({
  'Content-Type': 'application/x-www-form-urlencoded',
  post: {
    'Accept': 'text/html',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  transformRequest: [function (data) {
    // return qs.stringify(data)
    //console.log('------------http参数--------------')
   console.log("请求参数:"+JSON.stringify(data));
    
    var paramsData=$encruptionData(JSON.stringify(data));
    //console.log("请求参数:"+paramsData)

    return paramsData;
  }],
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  // timeout: 5000,
  baseURL: process.env.API_ROOT,
  // withCredentials:true
})


//添加一个请求拦截器
instance.interceptors.request.use(function (config) {
  console.log("配置拦截："+JSON.stringify(config))
  store.dispatch('showLoading');
  if (store.state.mutations.token) {
    config.headers.token = store.state.mutations.token;
  }
  console.log("store token"+store.state.mutations.token)

  console.log("local token"+localStorage.getItem("token"))

  if (store.state.mutations.stoken) {
    config.headers.stoken = store.state.mutations.stoken;
  }
  if (store.state.mutations.channel) {
    config.headers.cid = store.state.mutations.channel;
  }else{
    config.headers.cid = 'Y000014'
  }

  if (store.state.mutations.appflag) {
    config.headers.appflag = store.state.mutations.appflag;
  }

  if (store.state.mutations.mjb) {
    config.headers.mjn = store.state.mutations.mjb;
  }else{
    config.headers.mjn = 'hyb'
  }

  config.headers.dt = 4;
  if(store.state.mutations.appflag){
    let ua = navigator.userAgent.toLowerCase();
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //Ios
      config.headers.dt  = 1
   } else {
      //Android终端
      config.headers.dt = 2
   }

  }
  
  config.headers.dt = 4;
  console.log("产品id："+store.state.mutations.pid)
  if (store.state.mutations.pid) {
    config.headers.pid = store.state.mutations.pid;
  }else{
    config.headers.pid = 1001;
  }


  //在请求发送之前做一些事
  return config;
}, function (error) {
  console.log(error)
  //当出现请求错误是做一些事
  return Promise.reject(error);
});

//添加一个返回拦截器
instance.interceptors.response.use(function (response) {
  //对返回的数据进行一些处理
  store.dispatch('hideLoading');
  console.log("请求结果:"+JSON.stringify(response));

  // 401表示登录失效
  if (response.data.code == 401 ) {
    switch (response.data.code) {
      case 401:
        // 401 清除token信息并跳转到登录页面
        router.replace({
          path: '/login',
          // query: {redirect: router.currentRoute.fullPath}
          //query: {redirect: '/index'}
        })
    }
    store.dispatch('hideLoading');

  }
  return response.data;
}, function (error) {
  //对返回的数据进行一些处理
  store.dispatch('hideLoading');

  console.log("错误结果",error)
  console.log(error.response)
  switch (error.response.status) {
    case 504:
      tips.toast('504,服务器器错误');
      break;
    case 500:
      tips.toast('500,服务器器错误');
      break;
  }
  store.dispatch('hideLoading');
  //对返回的错误进行一些处理
  return Promise.reject(error);
});


export default instance


// WEBPACK FOOTER //
// ./src/utils/axios-http.js